export enum NotifcationTypes {
  success = "success",
  error = "error",
  info = "info",
  warning = "warn"
}
